import PropTypes from 'prop-types';
import React, { createContext, useEffect, useState } from 'react';
import CustomerSelfManagementStore from 'stores/CustomerSelfManagement/CustomerSelfManagementStore';

export const CustomerSelfManagementStoreContext = createContext(null);

export const PublicStoreProvider = ({ children }) => {
    const [customerSelfManagementStore] = useState(() => {
        const store = new CustomerSelfManagementStore();
        store.setPlatformByPath(window.location.pathname);
        return store;
    });

    useEffect(() => {
        const fetchPlatforms = async () => {
            await customerSelfManagementStore.listPlatforms();
        };

        fetchPlatforms();
    }, [customerSelfManagementStore]);

    return (
        <CustomerSelfManagementStoreContext.Provider value={customerSelfManagementStore}>
            {children}
        </CustomerSelfManagementStoreContext.Provider>
    );
};

PublicStoreProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
